// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Expln_2D = require("../../rescript-utils/main/Expln_2D.res.js");
var Caml_int32 = require("rescript/lib/js/caml_int32.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var Caml_splice_call = require("rescript/lib/js/caml_splice_call.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");

var subsAvailableColors = [
  "green",
  "orange",
  "#03a9f4",
  "pink",
  "brown",
  "lawngreen",
  "olive",
  "blue",
  "red",
  "magenta"
];

function viewBox(b) {
  return String(Expln_2D.Svg2D.bndMinX(b)) + (" " + String(Expln_2D.Svg2D.bndMinY(b))) + (" " + String(Expln_2D.Svg2D.bndWidth(b))) + (" " + String(Expln_2D.Svg2D.bndHeight(b)));
}

function rndSvg(boundaries, content) {
  var bndWidth = Expln_2D.Svg2D.bndWidth(boundaries);
  var bndHeight = Expln_2D.Svg2D.bndHeight(boundaries);
  return React.createElement("svg", {
              height: String(bndHeight / 1.3),
              width: String(bndWidth / 1.3),
              viewBox: viewBox(boundaries)
            }, content);
}

function vecToLine(v, colorOpt, key, lineWidth) {
  var color = colorOpt !== undefined ? colorOpt : "black";
  var b = Expln_2D.Svg2D.vecBegin(v);
  var e = Expln_2D.Svg2D.vecEnd(v);
  return [
          React.createElement("line", {
                key: key,
                stroke: color,
                strokeWidth: String(lineWidth),
                x1: String(Expln_2D.Svg2D.pntX(b)),
                x2: String(Expln_2D.Svg2D.pntX(e)),
                y1: String(Expln_2D.Svg2D.pntY(b)),
                y2: String(Expln_2D.Svg2D.pntY(e))
              }),
          Expln_2D.Svg2D.bndFromPoints([
                Expln_2D.Svg2D.vecBegin(v),
                Expln_2D.Svg2D.vecEnd(v)
              ])
        ];
}

function polyline(ps, color, lineWidth, key) {
  return [
          React.createElement("polyline", {
                key: key,
                style: {
                  fill: "none",
                  stroke: color,
                  strokeWidth: String(lineWidth)
                },
                points: ps.map(function (p) {
                        return String(Expln_2D.Svg2D.pntX(p)) + "," + String(Expln_2D.Svg2D.pntY(p));
                      }).join(" ")
              }),
          Expln_2D.Svg2D.bndFromPoints(ps)
        ];
}

function rect(bnd, color, lineWidth, key) {
  var p1 = Expln_2D.Svg2D.bndLeftBottom(bnd);
  var p2 = Expln_2D.Svg2D.bndLeftTop(bnd);
  var p3 = Expln_2D.Svg2D.bndRightTop(bnd);
  var p4 = Expln_2D.Svg2D.bndRightBottom(bnd);
  return polyline([
              p1,
              p2,
              p3,
              p4,
              p1
            ], color, lineWidth, key);
}

function text(ex, text$1, key, colorOpt, boldOpt, onClick) {
  var color = colorOpt !== undefined ? colorOpt : "black";
  var bold = boldOpt !== undefined ? boldOpt : false;
  var ey = Expln_2D.Svg2D.vecRot(ex, Expln_2D.Svg2D.deg(90));
  var fontSize = 20 * Expln_2D.Svg2D.vecLen(ex);
  var yShift = fontSize * 0.21;
  var at = Expln_2D.Svg2D.pntTr(Expln_2D.Svg2D.vecBegin(ex), Expln_2D.Svg2D.vecMul(ey, yShift));
  var charHeight = fontSize * 0.84;
  var charWidth = fontSize * 0.6;
  return [
          React.createElement("text", {
                key: key,
                style: {
                  cursor: Belt_Option.isSome(onClick) ? "pointer" : "default",
                  whiteSpace: "pre"
                },
                onClick: onClick,
                fill: color,
                fontFamily: "courier",
                fontSize: String(fontSize),
                fontWeight: bold ? "bold" : "normal",
                x: String(Expln_2D.Svg2D.pntX(at)),
                y: String(Expln_2D.Svg2D.pntY(at))
              }, text$1),
          Expln_2D.Svg2D.bndFromVectors([
                Expln_2D.Svg2D.vecMul(ex, charWidth * text$1.length),
                Expln_2D.Svg2D.vecMul(ey, charHeight)
              ])
        ];
}

function rndStmt(ex, stmt, symToColor, key) {
  var elems = [];
  var bnds = [];
  var curEx = {
    contents: ex
  };
  var printSymbol = function (sym, key) {
    var color = symToColor(sym);
    var match = text(curEx.contents, sym, key, Belt_Option.getWithDefault(color, "black"), Belt_Option.isSome(color), undefined);
    var bnd = match[1];
    elems.push(match[0]);
    bnds.push(bnd);
    curEx.contents = Expln_2D.Svg2D.vecTr(curEx.contents, Expln_2D.Svg2D.vecMul(ex, Expln_2D.Svg2D.bndWidth(bnd)));
  };
  var contentOnlyBnd = [];
  for(var i = 0 ,i_finish = stmt.length; i < i_finish; ++i){
    var subKey = key + "-" + String(i);
    printSymbol(stmt[i], subKey + "-S");
    if (i === (stmt.length - 1 | 0)) {
      contentOnlyBnd.push(Expln_2D.Svg2D.bndMergeAll(bnds));
    }
    printSymbol(" ", subKey + "-s");
  }
  return [
          elems,
          Expln_2D.Svg2D.bndMergeAll(bnds),
          contentOnlyBnd[0]
        ];
}

function testTextRendering() {
  var testText = "|Test gy ..WW..";
  var match = text(Expln_2D.Svg2D.ex, testText, undefined, undefined, true, undefined);
  var textBnd1 = match[1];
  var textHeight = Expln_2D.Svg2D.bndHeight(textBnd1);
  var lineWidth = textHeight * 0.01;
  var match$1 = rect(textBnd1, "yellow", lineWidth, undefined);
  var match$2 = rect(textBnd1, "green", lineWidth * 10, undefined);
  var match$3 = text(Expln_2D.Svg2D.vecTr(Expln_2D.Svg2D.ex, Expln_2D.Svg2D.vecMul(Expln_2D.Svg2D.vecRev(Expln_2D.Svg2D.ey), textHeight * 1.1)), testText, undefined, undefined, false, undefined);
  var textBnd2 = match$3[1];
  var match$4 = rect(textBnd2, "yellow", lineWidth, undefined);
  var match$5 = rect(textBnd2, "blue", lineWidth * 10, undefined);
  var testText2 = "|- AbCdEf       WWW eee ... AbCdEf  WWW eee ... AbCdEf  WWW eee ... AbCdEf  WWW eee ... |||";
  var match$6 = text(Expln_2D.Svg2D.vecTr(Expln_2D.Svg2D.ex, Expln_2D.Svg2D.vecMul(Expln_2D.Svg2D.vecRev(Expln_2D.Svg2D.ey), 2 * textHeight * 1.1)), testText2, undefined, undefined, false, undefined);
  var textBnd3 = match$6[1];
  var charWidth = Expln_2D.Svg2D.bndWidth(textBnd3) / testText2.length;
  var textBnd4Arr = [];
  var textElem4Arr = [];
  var ex4 = Expln_2D.Svg2D.vecTr(Expln_2D.Svg2D.ex, Expln_2D.Svg2D.vecMul(Expln_2D.Svg2D.vecRev(Expln_2D.Svg2D.ey), 3 * textHeight * 1.1));
  var dx = Expln_2D.Svg2D.vecMul(Expln_2D.Svg2D.ex, charWidth);
  for(var i = 0 ,i_finish = testText2.length; i < i_finish; ++i){
    var match$7 = text(ex4, testText2.charAt(i), String(i), undefined, false, undefined);
    textElem4Arr.push(match$7[0]);
    textBnd4Arr.push(match$7[1]);
    ex4 = Expln_2D.Svg2D.vecTr(ex4, dx);
  }
  return rndSvg(Expln_2D.Svg2D.bndAddMarginPct(Expln_2D.Svg2D.bndMergeAll([
                        textBnd1,
                        match$1[1],
                        match$2[1],
                        textBnd2,
                        match$4[1],
                        match$5[1],
                        textBnd3
                      ].concat(textBnd4Arr)), 0.01, undefined, undefined, undefined, undefined), React.createElement(React.Fragment, {}, match$2[0], match$1[0], match[0], match$5[0], match$4[0], match$3[0], match$6[0], textElem4Arr));
}

function rndConnection(bnd1, bnd2, color, key, noFrameForBottomBnd) {
  var bndHeight = Expln_2D.Svg2D.bndHeight(bnd1);
  var lineWidth = bndHeight * 0.05;
  var match = Expln_2D.Svg2D.bndMinY(bnd1) <= Expln_2D.Svg2D.bndMinY(bnd2) ? [
      bnd1,
      bnd2
    ] : [
      bnd2,
      bnd1
    ];
  var bottomBnd = match[1];
  var topBnd = match[0];
  var margin = bndHeight * 0.4;
  var topBnd$1 = noFrameForBottomBnd ? Expln_2D.Svg2D.bndAddMargin(topBnd, undefined, undefined, undefined, margin, margin) : topBnd;
  var bottomBnd$1 = noFrameForBottomBnd ? bottomBnd : Expln_2D.Svg2D.bndAddMargin(bottomBnd, undefined, undefined, undefined, margin, margin);
  var match$1 = rect(topBnd$1, color, lineWidth, "bnd-top-" + key);
  var match$2 = rect(bottomBnd$1, color, lineWidth, "bnd-bottom-" + key);
  var lineVec = Expln_2D.Svg2D.pntVec(Expln_2D.Svg2D.vecEnd(Expln_2D.Svg2D.vecMul(Expln_2D.Svg2D.pntVec(Expln_2D.Svg2D.bndLeftBottom(topBnd$1), Expln_2D.Svg2D.bndRightBottom(topBnd$1)), 0.5)), Expln_2D.Svg2D.vecEnd(Expln_2D.Svg2D.vecMul(Expln_2D.Svg2D.pntVec(Expln_2D.Svg2D.bndLeftTop(bottomBnd$1), Expln_2D.Svg2D.bndRightTop(bottomBnd$1)), 0.5)));
  var match$3 = vecToLine(lineVec, color, "line-" + key, lineWidth);
  var lBnd = match$3[1];
  var lElem = match$3[0];
  if (noFrameForBottomBnd) {
    return [
            [
              match$1[0],
              lElem
            ],
            Expln_2D.Svg2D.bndMergeAll([
                  match$1[1],
                  lBnd
                ])
          ];
  } else {
    return [
            [
              match$2[0],
              lElem
            ],
            Expln_2D.Svg2D.bndMergeAll([
                  match$2[1],
                  lBnd
                ])
          ];
  }
}

function rndStmtAndHyp(ctxFirst, frmStmt, hypLabel, onLabelClick, subs, subsColors, frmColors, ctxColors1, ctxColors2, noFrameForBottomBnd) {
  return function (ex) {
    var frmSymToColor = function (sym) {
      return Belt_Option.flatMap(frmColors, (function (frmColors) {
                    return Belt_HashMapString.get(frmColors, sym);
                  }));
    };
    var ctxSymToColor = function (sym) {
      var color = Belt_Option.flatMap(ctxColors1, (function (ctxColors1) {
              return Belt_HashMapString.get(ctxColors1, sym);
            }));
      if (color !== undefined) {
        return color;
      } else {
        return Belt_Option.flatMap(ctxColors2, (function (ctxColors2) {
                      return Belt_HashMapString.get(ctxColors2, sym);
                    }));
      }
    };
    var getCtxSubStmt = function (frmSym) {
      var ctxSubStmt = Belt_HashMapString.get(subs, frmSym);
      if (ctxSubStmt !== undefined) {
        return ctxSubStmt;
      } else {
        return [frmSym];
      }
    };
    var rndCtxStmt = ctxFirst || frmStmt.some(function (__x) {
          return Belt_HashMapString.has(subs, __x);
        });
    var match = text(ex, ".", undefined, undefined, undefined, undefined);
    var bndSample = match[1];
    var charHeight = Expln_2D.Svg2D.bndHeight(bndSample);
    var charWidth = Expln_2D.Svg2D.bndWidth(bndSample);
    var ctxStmtStr = Expln_utils_common.arrFlatMap(frmStmt, getCtxSubStmt).join(" ");
    var ctxStmtLen = ctxStmtStr.length * charWidth;
    var frmStmtLen = frmStmt.join(" ").length * charWidth;
    var dx = (ctxStmtLen - frmStmtLen) / 2;
    var exS = Expln_2D.Svg2D.vecTr(ex, Expln_2D.Svg2D.vecMul(ex, dx));
    var match$1 = ctxFirst ? [
        {
          contents: Expln_2D.Svg2D.vecTr(ex, Expln_2D.Svg2D.vecMul(Expln_2D.Svg2D.ey, charHeight * 3.3))
        },
        {
          contents: exS
        }
      ] : [
        {
          contents: ex
        },
        {
          contents: rndCtxStmt ? Expln_2D.Svg2D.vecTr(exS, Expln_2D.Svg2D.vecMul(Expln_2D.Svg2D.ey, charHeight * 3.3)) : ex
        }
      ];
    var frmEx = match$1[1];
    var ctxEx = match$1[0];
    var frmElems = [];
    var ctxElems = [];
    var conElems = [];
    var bnds = [];
    frmStmt.forEach(function (frmSym, i) {
          var match = rndStmt(frmEx.contents, [frmSym], frmSymToColor, "frm-" + String(i));
          var frmBnd = match[1];
          Caml_splice_call.spliceObjApply(frmElems, "push", [match[0]]);
          bnds.push(frmBnd);
          frmEx.contents = Expln_2D.Svg2D.vecTr(frmEx.contents, Expln_2D.Svg2D.vecMul(ex, Expln_2D.Svg2D.bndWidth(frmBnd)));
          if (!rndCtxStmt) {
            return ;
          }
          var match$1 = rndStmt(ctxEx.contents, getCtxSubStmt(frmSym), ctxSymToColor, "ctx-" + String(i));
          var ctxBnd = match$1[1];
          Caml_splice_call.spliceObjApply(ctxElems, "push", [match$1[0]]);
          bnds.push(ctxBnd);
          ctxEx.contents = Expln_2D.Svg2D.vecTr(ctxEx.contents, Expln_2D.Svg2D.vecMul(ex, Expln_2D.Svg2D.bndWidth(ctxBnd)));
          var color = Belt_HashMapString.get(subsColors, frmSym);
          if (color === undefined) {
            return ;
          }
          var match$2 = rndConnection(match[2], match$1[2], color, String(i), noFrameForBottomBnd);
          conElems.push(match$2[0]);
          bnds.push(match$2[1]);
        });
    if (hypLabel !== undefined) {
      var stmtsBnd = Expln_2D.Svg2D.bndMergeAll(bnds);
      var match$2 = text(Expln_2D.Svg2D.vecTr(Expln_2D.Svg2D.vecNorm(Expln_2D.Svg2D.pntVec(Expln_2D.Svg2D.bndLeftTop(stmtsBnd), Expln_2D.Svg2D.bndRightTop(stmtsBnd))), Expln_2D.Svg2D.vecMul(Expln_2D.Svg2D.ey, charHeight)), hypLabel, "label", "darkgrey", false, onLabelClick);
      bnds.push(match$2[1]);
      ctxElems.push(match$2[0]);
    }
    return [
            conElems.concat(frmElems).concat(ctxElems),
            Expln_2D.Svg2D.bndMergeAll(bnds)
          ];
  };
}

function MM_cmp_jstf_to_svg(props) {
  var onLabelClick = props.onLabelClick;
  var ctxColors2 = props.ctxColors2;
  var ctxColors1 = props.ctxColors1;
  var frmColors = props.frmColors;
  var subs = props.subs;
  var asrt = props.asrt;
  var hypLabels = props.hypLabels;
  var hyps = props.hyps;
  var match = text(Expln_2D.Svg2D.ex, ".", undefined, undefined, undefined, undefined);
  var charHeight = Expln_2D.Svg2D.bndHeight(match[1]);
  var hypMargin = charHeight * 3;
  var delimLineWidth = charHeight * 0.05;
  var delimLineMargin = charHeight * 0.5;
  var numOfColors = subsAvailableColors.length;
  var subsColors = Belt_HashMapString.fromArray(Belt_HashMapString.toArray(subs).map(function (param, i) {
            return [
                    param[0],
                    subsAvailableColors[Caml_int32.mod_(i, numOfColors)]
                  ];
          }));
  var rndContent = function () {
    var curEx = {
      contents: Expln_2D.Svg2D.ex
    };
    var hypElems = [];
    var hypBnds = [];
    hyps.forEach(function (hyp, i) {
          var match = rndStmtAndHyp(true, hyp, hypLabels[i], Belt_Option.map(onLabelClick, (function (onLabelClick) {
                        return MM_react_common.clickHnd(undefined, undefined, undefined, undefined, (function () {
                                      onLabelClick(i, hypLabels[i]);
                                    }));
                      })), subs, subsColors, frmColors, ctxColors1, ctxColors2, true)(curEx.contents);
          var bnd = match[1];
          hypElems.push(match[0]);
          hypBnds.push(bnd);
          curEx.contents = Expln_2D.Svg2D.vecTr(curEx.contents, Expln_2D.Svg2D.vecMul(Expln_2D.Svg2D.ex, Expln_2D.Svg2D.bndWidth(bnd) + hypMargin));
        });
    var asrtComp = rndStmtAndHyp(false, asrt, undefined, undefined, subs, subsColors, frmColors, ctxColors1, ctxColors2, false);
    var match = asrtComp(Expln_2D.Svg2D.ex);
    var asrtSampleBnd = match[1];
    var match$1;
    if (hyps.length === 0) {
      var match$2 = vecToLine(Expln_2D.Svg2D.pntVec(Expln_2D.Svg2D.bndLeftTop(asrtSampleBnd), Expln_2D.Svg2D.bndRightTop(asrtSampleBnd)), "black", "delim-line", delimLineWidth);
      match$1 = [
        match$2[0],
        match$2[1]
      ];
    } else {
      var hypsBnd = Expln_2D.Svg2D.bndMergeAll(hypBnds);
      var match$3 = vecToLine(Expln_2D.Svg2D.vecTr(Expln_2D.Svg2D.vecMul(Expln_2D.Svg2D.vecNorm(Expln_2D.Svg2D.pntVec(Expln_2D.Svg2D.bndLeftBottom(hypsBnd), Expln_2D.Svg2D.bndRightBottom(hypsBnd))), Math.max(Expln_2D.Svg2D.bndWidth(hypsBnd), Expln_2D.Svg2D.bndWidth(asrtSampleBnd))), Expln_2D.Svg2D.vecMul(Expln_2D.Svg2D.ey, - delimLineMargin)), "black", "delim-line", delimLineWidth);
      match$1 = [
        hypElems.concat([match$3[0]]),
        Expln_2D.Svg2D.bndMergeAll([
              hypsBnd,
              match$3[1]
            ])
      ];
    }
    var hypsBnd$1 = match$1[1];
    var match$4 = asrtComp(Expln_2D.Svg2D.vecTr(Expln_2D.Svg2D.vecNorm(Expln_2D.Svg2D.pntVec(Expln_2D.Svg2D.bndLeftBottom(hypsBnd$1), Expln_2D.Svg2D.bndRightBottom(hypsBnd$1))), Expln_2D.Svg2D.vecMul(Expln_2D.Svg2D.ey, - (delimLineMargin + Expln_2D.Svg2D.bndHeight(asrtSampleBnd)))));
    return rndSvg(Expln_2D.Svg2D.bndAddMargin(Expln_2D.Svg2D.bndMergeAll([
                        hypsBnd$1,
                        match$4[1]
                      ]), charHeight * 0.3, undefined, undefined, undefined, undefined), React.createElement(React.Fragment, {}, match$1[0], match$4[0]));
  };
  return React.createElement("table", {
              style: {
                tableLayout: "fixed",
                width: "100%"
              }
            }, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, React.createElement("div", {
                              style: {
                                overflow: "auto",
                                width: "100%"
                              }
                            }, rndContent())))));
}

var pxSize = 1.3;

var make = MM_cmp_jstf_to_svg;

exports.pxSize = pxSize;
exports.subsAvailableColors = subsAvailableColors;
exports.viewBox = viewBox;
exports.rndSvg = rndSvg;
exports.vecToLine = vecToLine;
exports.polyline = polyline;
exports.rect = rect;
exports.text = text;
exports.rndStmt = rndStmt;
exports.testTextRendering = testTextRendering;
exports.rndConnection = rndConnection;
exports.rndStmtAndHyp = rndStmtAndHyp;
exports.make = make;
/* react Not a pure module */
